import { adminAPIService, newhopeAPIService } from './index'

const route = 'paylinks'

export const getCPCList = () => {
  return newhopeAPIService({
    url: `${route}/cpc`,
    method: 'get',
  })
}

export const createBitlyLinks = (longLinks) => {
  const formData = new FormData()
  formData.append('json', JSON.stringify(longLinks))

  return adminAPIService({
    url: `${route}/create-bitly-links`,
    method: 'post',
    data: formData,
  })
}

export const createLinkMeta = (title, bannerImage) => {
  const payload = {
    title: title,
    banner_image: bannerImage
  }

  const formData = new FormData()
  formData.append('json', JSON.stringify(payload))

  return adminAPIService({
    url: `${route}/create-link-meta`,
    method: 'post',
    data: formData,
  })
}